export default __webpack_public_path__ + "static/6-060331e60b9efb870c83451d6ba47edb.jpg";